import React from 'react';

function LoadingState({ rows = 5, type = 'list' }) {
  if (type === 'stats') {
    return (
      <div className="stats-grid">
        {[1,2,3,4].map(i => (
          <div key={i} className="skeleton" style={{ height: 90, borderRadius: 8 }} />
        ))}
      </div>
    );
  }
  if (type === 'cards') {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 16 }}>
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="skeleton" style={{ height: 140, borderRadius: 8 }} />
        ))}
      </div>
    );
  }
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton" style={{ height: 56, borderRadius: 8 }} />
      ))}
    </div>
  );
}

export default LoadingState;
